import React from 'react';
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import { AppConfig } from '../AppConfig';
import './HistoryPage.css'

interface HistoryPageState {
  loading: boolean;
  log: any[];
}

class HistoryPage extends React.Component<{}, HistoryPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      loading: false,
      log: []
    }
  }
  componentDidMount() {
    this.loadHistory();
  }

  async loadHistory() {
    this.setState({loading: true});
    let response = await Server.user.getLog();
    this.setState({loading: false});
    if(response.success)
      this.setState({log: response.log});
  }

  render() {
    if(this.state.loading) {
      return (
        <div className="history-page">
          Loading...
        </div>
      );
    }

    let rows = [];
    for(let i = 0; i < this.state.log.length; i++) {
      let log = this.state.log[i];
      let d = new Date(log.date);
      let eventName = log.event;
      let eventData = '';
      let gameId = '';
      let tournament = false;
      let profile = null;
      let assets = [];

      switch(log.event) {
        case 'login':
          eventName = 'Logged In';
          break;
        case 'open-pack':
          eventName = 'Opened ' + Database.getAsset(log.data.id).name;
          assets = [];
          for(let i = 0; i < log.data.assets.length; i++)
            assets.push(log.data.assets[i].quantity + ' ' + Database.getAsset(log.data.assets[i].id).name);
          eventData = assets.join(', ');
          break;
        case 'craft-asset':
          eventName = 'Crafted ' + Database.getAsset(log.data.output[0].id).name;
          if(log.data.input) {
            assets = [];
            for(let i = 0; i < log.data.input.length; i++)
              assets.push(log.data.input[i].quantity + ' ' + Database.getAsset(log.data.input[i].id).name);
            eventData = 'Ingredients: ' + assets.join(', ');
          }
          break;
        case 'purchase-asset':
          eventName = 'Purchased ' + Database.getAsset(log.data.id).name;
          if(log.data.quantity > 1)
            eventName += ' (x' + log.data.quantity + ')';
          break;
        case 'start-game':
          gameId = log.data.id;
          tournament = false;
          if(gameId.indexOf('-tournament') != -1) {
            gameId = gameId.substring(0, gameId.length-11);
            tournament = true;
          }
          eventName = 'Started ' + Database.getGame(gameId).name + (tournament ? ' Contest' : '');
          break;
        case 'finish-game':
          gameId = log.data.id;
          tournament = false;
          if(gameId.indexOf('-tournament') != -1) {
            gameId = gameId.substring(0, gameId.length-11);
            tournament = true;
          }
          eventName = 'Finished ' + Database.getGame(gameId).name + (tournament ? ' Contest' : '');
          let rewards = [];
          if(log.data.coins > 0)
            rewards.push(log.data.coins + ' Coins');
          if(log.data.asset != '')
            rewards.push(Database.getAsset(log.data.asset).name)
          if(rewards.length == 0)
            rewards.push('None');
          eventData = 'Score: ' + log.data.score + ', Reward: ' + rewards.join(', ');
          break;
        case 'consume-asset':
          eventName = 'Consumed ' + Database.getAsset(log.data.id).name;
          break;
        case 'accept-friend':
          eventName = 'Accepted Friend';
          profile = Server.public.getProfile(log.data.friend);
          if(profile)
            eventData = profile.name;
          break;
        case 'invite-friend':
          eventName = 'Invited Friend';
          profile = Server.public.getProfile(log.data.friend);
          if(profile)
            eventData = profile.name;
          break;
        case 'decline-friend':
          eventName = 'Declined Friend';
          profile = Server.public.getProfile(log.data.friend);
          if(profile)
            eventData = profile.name;
          break;
        case 'remove-friend':
          eventName = 'Removed Friend';
          profile = Server.public.getProfile(log.data.friend);
          if(profile)
            eventData = profile.name;
          break;
        case 'purchase-tokens':
          eventName = 'Purchased ' + log.data.quantity + ' ' + AppConfig.token.symbol;
          break;
        case 'sell-tokens':
          eventName = 'Sold ' + log.data.quantity + ' ' + AppConfig.token.symbol;
          break;
        case 'transfer-tokens':
          eventName = 'Sent ' + log.data.quantity + ' ' + AppConfig.token.symbol;
          profile = Server.public.getProfile(log.data.friend);
          if(profile)
            eventName += ' to ' + profile.name;
          break;
        case 'receive-tokens':
          eventName = 'Received ' + log.data.quantity + ' ' + AppConfig.token.symbol;
          profile = Server.public.getProfile(log.data.friend);
          if(profile)
            eventName += ' from ' + profile.name;
          break;
        case 'send-gift':
          eventName = 'Sent ' + log.data.quantity + ' ' + Database.getAsset(log.data.asset).name;
          profile = Server.public.getProfile(log.data.friend);
          if(profile)
            eventName += ' to ' + profile.name;
          break;
        case 'receive-gift':
          eventName = 'Received ' + log.data.quantity + ' ' + Database.getAsset(log.data.asset).name;
          profile = Server.public.getProfile(log.data.friend);
          if(profile)
            eventName += ' from ' + profile.name;
          break;
      }

      rows.push(
        <div key={i} className="history-page-row">
          <div style={{whiteSpace: 'nowrap'}}>{d.toLocaleTimeString()}<br/><div style={{color: '#ffffff80'}}>{d.toLocaleDateString()}</div></div>
          <div>{eventName}<br/><div style={{color: '#ffffff80'}}>{eventData}</div></div>
        </div>
      )
    }

    return (
      <div className="history-page">
        {rows}
      </div>
    );
  }
}

export default HistoryPage;
